import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';
import { sortValues } from '../../../constants/PravoEuSortConstants';

const PravoEuListSort = (): ReactElement => (
  <SortSelect sortList={[
    {
      sort: sortValues[0],
      title: 'Dátum uverejnenia (od najnovších)',
      sortBy: 'desc',
    },
    {
      sort: sortValues[0],
      title: 'Dátum uverejnenia (od najstarších)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[1],
      title: 'Názov (A-Z)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[1],
      title: 'Názov (Z-A)',
      sortBy: 'desc',
    },
    {
      sort: sortValues[2],
      title: 'Typ (A-Z)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[2],
      title: 'Typ (Z-A)',
      sortBy: 'desc',
    },
  ]}
  />
);

export default PravoEuListSort;
